const apiUrl = new URL(import.meta.env.VITE_API_URL);

export function getAppType() {
  const split = apiUrl.hostname.split('.');
  let domain = split[split.length - 2];

  if (import.meta.env.VITE_FORCE_SITE) {
    domain = import.meta.env.VITE_FORCE_SITE;
  }
  
  switch (domain) {
    case 'viberuzenetek':
      return 'viber-uzenetek';
    case 'conversioncraft':
    default:
      return 'conversion-craft';
  }
}

export function getAppBrandColor() {
  const appType = getAppType();

  switch (appType) {
    case 'viber-uzenetek':
      return 'bg-[#7541a3]';
    default:
      return 'bg-primary';
  }
}

export function getAppBrandColorNative() {
  const appType = getAppType();

  switch (appType) {
    case 'viber-uzenetek':
      return '#7541a3';
    default:
      return '#0078d4';
  }
}

export type AppDataType = {
  name: string;
  host: string;
};

export function getAppData(): AppDataType {
  const appType = getAppType();

  switch (appType) {
    case 'viber-uzenetek':
      return {
        name: 'Viber Üzenetek',
        host: 'viberuzenetek.hu',
      };
    default:
      return {
        name: 'Conversion Craft',
        host: 'conversioncraft.ai',
      };
  }
}
